<template>
  <div class="notice-popup">
    <div class="popup-header">
      <div class="header-content">
        <i class="fa fa-cogs text-primary"></i>
        <h2 class="title">CAMDS System Update Notification</h2>
        <span class="version">Version 12.1</span>
      </div>
      <button class="close-btn">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- 弹窗内容 -->
    <div class="popup-body">
      <div class="update-date">
        <i class="fa fa-calendar-o"></i>
        <span>Update Date: August 27, 2025</span>
      </div>

      <div class="update-content">
        <h3 class="content-title">The update content is as follows:</h3>

        <ul class="update-list">
          <li class="update-item">
            <span class="item-number">1.</span>
            <span>The auxiliary validation tool can also perform custom rule validation for self-built forms.</span>
          </li>
          <li class="update-item">
            <span class="item-number">2.</span>
            <span>The BOM upload function (Advanced Upload Tool) interface has added an "Edit" button, allowing the uploaded data to directly enter the edit page.</span>
          </li>
          <li class="update-item important">
            <span class="item-number">3.</span>
            <span>For substances marked as confidential, such as those included in the GADSL list, the system will automatically publish the substance.</span>
            <span class="important-tag">Important</span>
          </li>
          <li class="update-item">
            <span class="item-number">4.</span>
            <span>The issue of slow upload speed for large forms in the IC conversion tool has been optimized.</span>
          </li>
          <li class="update-item">
            <span class="item-number">5.</span>
            <span>The SCIP notification obligation analysis function has been further improved. It can run in the background after starting the analysis and can display the current progress.</span>
          </li>
          <li class="update-item">
            <span class="item-number">6.</span>
            <span>When viewing the received list, you can customize the display or hide columns.</span>
          </li>
          <li class="update-item">
            <span class="item-number">7.</span>
            <span>In the C2C tool export data table, the part number has been changed from the component number to the supply number.</span>
          </li>
          <li class="update-item">
            <span class="item-number">8.</span>
            <span>Bugs currently identified have been fixed.</span>
            <ul class="bug-list">
              <li><span class="bug-number">1)</span> The issue of online upload failure in the C2C conversion tool.</li>
              <li><span class="bug-number">2)</span> The error reported during the upload of the list in the auxiliary validation tool.</li>
              <li><span class="bug-number">3)</span> The problem of getting stuck when adding a contact for this company.</li>
              <li><span class="bug-number">4)</span> The issue of inconsistent node order in the commitment letter and the tree structure.</li>
              <li><span class="bug-number">5)</span> Partial issues with special character filtering.</li>
            </ul>
          </li>
        </ul>

        <div class="additional-info">
          <p>For detailed information, please refer to the latest user manual. If you have any further questions, please contact the CAMDS Management Center.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style scoped lang="scss">
.update-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.update-popup {
  width: 100%;
  max-width: 800px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

.popup-header {
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-content .fa-cogs {
  color: #165dff;
  font-size: 20px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
  margin: 0;
}

.version {
  font-size: 14px;
  color: #86909c;
  background-color: #f2f3f5;
  padding: 2px 8px;
  border-radius: 4px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #86909c;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background-color: #f2f3f5;
  color: #1d2129;
}

.popup-body {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.update-date {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #4e5969;
  margin-bottom: 20px;
  font-size: 14px;
}

.content-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #1d2129;
}

.update-list {
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
}

.update-item {
  margin-bottom: 12px;
  padding-left: 24px;
  position: relative;
  line-height: 1.5;
}

.item-number {
  position: absolute;
  left: 0;
  font-weight: 600;
  color: #165dff;
}

.important {
  padding-right: 60px;
}

.important-tag {
  position: absolute;
  right: 0;
  background-color: #f53f3f;
  color: white;
  font-size: 12px;
  padding: 1px 6px;
  border-radius: 3px;
  font-weight: 500;
}

.bug-list {
  list-style: none;
  padding: 8px 0 0 24px;
  margin: 0;
}

.bug-list li {
  margin-bottom: 6px;
  position: relative;
  padding-left: 20px;
}

.bug-number {
  position: absolute;
  left: 0;
  color: #86909c;
}

.additional-info {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px dashed #e5e6eb;
  color: #4e5969;
  font-size: 14px;
}

.popup-footer {
  padding: 16px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.manual-btn,
.contact-btn,
.confirm-btn {
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}

.manual-btn {
  color: #165dff;
  background-color: #e8f3ff;
  border-color: #d1e9ff;
}

.manual-btn:hover {
  background-color: #d1e9ff;
}

.contact-btn {
  color: #00b42a;
  background-color: #e6ffed;
  border-color: #b7eb8f;
}

.contact-btn:hover {
  background-color: #b7eb8f;
}

.confirm-btn {
  color: white;
  background-color: #165dff;
}

.confirm-btn:hover {
  background-color: #0e42d2;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .popup-footer {
    flex-direction: column;
  }

  .manual-btn,
  .contact-btn,
  .confirm-btn {
    width: 100%;
  }

  .important {
    padding-right: 0;
  }

  .important-tag {
    position: static;
    margin-left: 8px;
  }
}
</style>
